import { useEncounter, useStaff } from '@hook'
import { yupResolver } from '@hookform/resolvers/yup'
import { FormButton, Modal, SelectInputField } from '@ui'
import { getError, showToast } from '@util'
import { Box, Form } from 'grommet'
import { debounce } from 'lodash'
import { useState } from 'react'
import { FormProvider, useForm } from 'react-hook-form'
import { InferType, object, string } from 'yup'

type Props = {
  onClose: () => void
  title?: string
  id?: string
}

const schema = object({
  staff_id: string().required('Staff is required')
})

export const Reassign = ({ onClose, title, id }: Props) => {
  const methods = useForm({ resolver: yupResolver(schema) })
  const [staffQuery, setStaffQuery] = useState('')
  const { staffs } = useStaff({ query: staffQuery, role: 'doctor' })
  const { updateEncounter } = useEncounter()

  const debouncedSearch = debounce((e: string) => {
    setStaffQuery(e)
  }, 400)
  const staffSearchhandle = (e: string) => {
    debouncedSearch(e)
  }
  const onSubmit = async ({ staff_id }: InferType<typeof schema>) => {
    const formRecObj = {
      data: {
        relationships: {
          appointed_staff: {
            data: {
              id: staff_id,
              type: 'staff'
            }
          }
        },
        type: 'encounter'
      }
    }
    try {
      await updateEncounter({ formVal: formRecObj, id: String(id) })
      showToast('Patient assigned Successfully')
      onClose()
    } catch (error) {
      getError(error)
    }
  }
  return (
    <FormProvider {...methods}>
      <Modal
        onClose={() => {
          onClose()
        }}
        title={title || 'Reassign Patient'}
      >
        <Form onSubmit={methods.handleSubmit(onSubmit)}>
          <Box pad={'30px'}>
            <Box>
              <SelectInputField
                dropProps={{
                  height: '300px'
                }}
                label="Search Staff"
                labelKey={({ attributes }) => `${attributes.first_name} ${attributes.last_name}`}
                name="staff_id"
                onSearch={staffSearchhandle}
                options={staffs || []}
                placeholder="Search Staff"
                searchPlaceholder="eg John doe"
                valueKey={{ key: 'id', reduce: true }}
              />
            </Box>
          </Box>
          <FormButton
            disabled={methods.formState.isSubmitting}
            isLoading={methods.formState.isSubmitting}
            onClose={onClose}
            submit="Assign"
          />
        </Form>
      </Modal>
    </FormProvider>
  )
}
